
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Calendar, MapPin, Users } from 'lucide-react';
import { getEvents } from '@/data/eventsData';
import TranslatedText from '@/TranslatedText';

const EventsTab: React.FC = () => {
  const events = getEvents().slice(0, 3); // Just show first 3 events for the tab
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="font-bold text-base">
          <TranslatedText text="Upcoming Events" />
        </h2>
        <Button className="bg-ahavex-blue text-xs">
          <Calendar className="mr-2 h-3 w-3" />
          <TranslatedText text="My Calendar" />
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {events.map(event => (
          <motion.div 
            key={event.id} 
            initial={{opacity: 0, y: 20}} 
            animate={{opacity: 1, y: 0}} 
            transition={{duration: 0.5}}
          >
            <Card className="overflow-hidden hover:shadow-md transition-shadow">
              <div className="bg-gradient-to-r from-purple-400 to-blue-500 p-2 text-white font-medium text-center text-xs">
                {event.date}
              </div>
              <CardContent className="pt-4">
                <h3 className="text-sm font-semibold mb-2">{event.name}</h3>
                <div className="flex items-start gap-2 mb-2">
                  <Calendar className="h-4 w-4 text-gray-500 mt-0.5" />
                  <div>
                    <p className="font-medium text-xs">{event.date}</p>
                    <p className="text-gray-500 text-xs">{event.time}</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 mb-2">
                  <MapPin className="h-4 w-4 text-gray-500 mt-0.5" />
                  <p className="text-xs">{event.location}</p>
                </div>
                <div className="flex items-center gap-2">
                  <Users className="h-4 w-4 text-gray-500" />
                  <p className="text-xs">{event.attendees} <TranslatedText text="attending" /></p>
                </div>
              </CardContent>
              <CardFooter className="pt-1 flex justify-end border-t">
                <Button className="text-xs h-7">
                  <TranslatedText text="Register Now" />
                </Button>
              </CardFooter>
            </Card>
          </motion.div>
        ))}
      </div>
      
      <div className="flex justify-center">
        <Button variant="outline" className="mt-2 text-xs">
          <TranslatedText text="View All Events" />
        </Button>
      </div>
    </div>
  );
};

export default EventsTab;
